<script>
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import BuildingTypes from '$lib/PageSections/BuildingTypes/BuildingTypes.svelte';
</script>

<Section backgroundColor="pro-grey-light">
	<h2 class="text-left">Proven in the Field, Trusted Nationwide</h2>
	<p class="text-left">
		Indow systems have been installed in thousands of commercial and
		institutional buildings across North America: from hotels and schools to
		city halls and office towers.
	</p>

	<BuildingTypes />
</Section>
